import { create } from 'zustand';
import useLoadingStore from './use-loading';
import { makeRequest } from 'api/api-client';
import { HTTP } from 'constants/http-method';
import { API_ENDPOINTS } from 'api/endpoints';

const useComplianceManagerStore = create((set) => ({
  complianceStates: [],
  compliancePositions: [],
  complianceLoading: false,
  complianceCategories: [],
  complianceRequirements: [],
  pagination: {
    pageSize: 10,
    totalItems: 0,
    totalPages: 0,
    currentPage: 1,
  },

  getComplianceRequirementCategories: async ({ id, successCallback }) => {
    try {
      const { data: response } = await makeRequest(
        HTTP.GET,
        API_ENDPOINTS.GET_COMPLIANCE_REQUIREMENT_CATEGORIES,
        null,
        null,
        id
      );

      if (response.success) {
        successCallback && successCallback(response);
      }
    } catch (error) {
    } finally {
      useLoadingStore.getState().setLoading(false);
    }
  },

  // Function to get compliance categories
  getComplianceManagerCategories: async () => {
    try {
      const { data: response } = await makeRequest(
        HTTP.GET,
        API_ENDPOINTS.GET_COMPLIANCE_MANAGER_CATEGORIES
      );

      if (response.success) {
        set({
          complianceCategories: response.data?.data || [],
        });
      }
    } catch (error) {
    } finally {
      useLoadingStore.getState().setLoading(false);
    }
  },

  // Function to get  requirements by category
  getComplianceRequirementsByCategory: async ({ label, successCallback }) => {
    try {
      let endpoint;
      switch (label) {
        case 'skill checklist':
          endpoint =
            API_ENDPOINTS.GET_COMPLIANCE_REQUIREMENT_BY_SKILL_CHECKLIST;
          break;
        case 'competency test':
          endpoint =
            API_ENDPOINTS.GET_COMPLIANCE_REQUIREMENT_BY_COMPETENCY_TEST;
          break;
        case 'reference form':
          endpoint = API_ENDPOINTS.GET_COMPLIANCE_REQUIREMENT_BY_REFERENCE_FORM;
          break;
        default:
          endpoint = '';
      }

      const { data: response } = await makeRequest(HTTP.GET, endpoint);

      if (response.success) {
        successCallback && successCallback(response);
      }
    } catch (error) {
    } finally {
      useLoadingStore.getState().setLoading(false);
    }
  },

  // Function to get compliance states
  getComplianceStates: async () => {
    try {
      const { data: response } = await makeRequest(
        HTTP.GET,
        API_ENDPOINTS.GET_COMPLIANCE_REQUIREMENT_STATES
      );

      if (response.success) {
        set({
          complianceStates: response.data?.data || [],
        });
      }
    } catch (error) {
    } finally {
      useLoadingStore.getState().setLoading(false);
    }
  },

  // Function to get compliance positions
  getCompliancePositions: async () => {
    try {
      const { data: response } = await makeRequest(
        HTTP.GET,
        API_ENDPOINTS.GET_COMPLIANCE_POSITIONS
      );

      if (response.success) {
        set({
          compliancePositions: response.data?.data || [],
        });
      }
    } catch (error) {
    } finally {
      useLoadingStore.getState().setLoading(false);
    }
  },

  // Function to get compliance requirement
  getComplianceRequirement: async ({ query = null, successCallback }) => {
    set({ complianceLoading: true });
    useLoadingStore.getState().setLoading(true);
    try {
      const { data: response } = await makeRequest(
        HTTP.GET,
        API_ENDPOINTS.GET_COMPLIANCE_REQUIREMENT,
        null,
        query
      );

      if (response.success) {
        set({
          complianceRequirements: response.data?.data || [],
          pagination: {
            pageSize: response.data?.pagination?.limit,
            totalItems: response.data?.pagination?.total,
            currentPage: response.data?.pagination?.page,
            totalPages: response.data?.pagination?.totalPages,
          },
        });

        successCallback && successCallback();
      }
    } catch (error) {
    } finally {
      set({ complianceLoading: false });
      useLoadingStore.getState().setLoading(false);
    }
  },

  // Function to create the compliance requirement
  createComplianceRequirement: async ({ data, successCallback }) => {
    useLoadingStore.getState().setLoading(true);
    try {
      const { data: response } = await makeRequest(
        HTTP.POST,
        API_ENDPOINTS.CREATE_COMPLIANCE_REQUIREMENT,
        data
      );

      if (response.success) {
        successCallback && successCallback(response);
      }
    } catch (error) {
    } finally {
      useLoadingStore.getState().setLoading(false);
    }
  },

  // Function to delete the compliance requirement
  deleteComplianceRequirement: async ({ id, successCallback }) => {
    useLoadingStore.getState().setLoading(true);
    try {
      const { data: response } = await makeRequest(
        HTTP.PUT,
        API_ENDPOINTS.DELETE_COMPLIANCE_REQUIREMENT,
        null,
        null,
        id
      );

      if (response.success) {
        successCallback && successCallback(response);
      }
    } catch (error) {
    } finally {
      useLoadingStore.getState().setLoading(false);
    }
  },

  // Function to update the compliance requirement
  updateComplianceRequirement: async ({ id, data, successCallback }) => {
    useLoadingStore.getState().setLoading(true);
    try {
      const { data: response } = await makeRequest(
        HTTP.PUT,
        API_ENDPOINTS.UPDATE_COMPLIANCE_REQUIREMENT,
        data,
        null,
        id
      );

      if (response.success) {
        successCallback && successCallback(response);
      }
    } catch (error) {
      // Handle error
    } finally {
      useLoadingStore.getState().setLoading(false);
    }
  },
}));

export default useComplianceManagerStore;
